export const loginCopy = {
  tr: {
    title: "Hoş geldiniz",
    logout_incomplete: "Hub oturumunuz kapatıldı ancak merkezi çıkış tamamlanamadı. Paylaşılan cihaz kullanıyorsanız merkezi hesabınızdan da çıkış yapın.",
    securityCheck: "Güvenlik doğrulaması",
    challengeFailure: "Güvenlik doğrulaması tamamlanamadı. Lütfen tekrar deneyin.",
    description: "Integration Hub’a kurumsal hesabınızla güvenli bir şekilde giriş yapın.",
    slogans: ["Bağlı sistemler", "Akıcı veri", "Güçlü entegrasyon"],
    unavailableTitle: "Giriş henüz etkin değil",
    unavailableDescription: "Kurumsal giriş hazırlığı sürüyor. Erişiminiz kullanıma açıldığında buradan devam edebilirsiniz.",
    submit: "Devam", submitting: "Erişiminiz kontrol ediliyor...",
    failed: "Giriş işlemi tamamlanamadı. Yeniden giriş yapın. Sorun sürerse yöneticinizle iletişime geçin.",
    access_denied: "Bu kuruluşta Integration Hub’a erişim yetkiniz yok. Yöneticinizden Hub rolünüzü ve erişim izinlerinizi kontrol etmesini isteyin.",
    login_unavailable: "Giriş hizmetine şu anda ulaşılamıyor. Biraz sonra tekrar deneyin. Sorun sürerse yöneticinizle iletişime geçin.",
    rejected: "Bu hesapla devam edilemedi. E-posta adresinizi kontrol edin veya sistem yöneticinizle iletişime geçin.",
    busy: "Şu anda çok sayıda giriş denemesi var. Lütfen biraz sonra tekrar deneyin.",
    delayed: "Giriş ekranı açılamadı. Lütfen tekrar deneyin.",
    emailRequired: "Kurumsal e-posta adresinizi girin.",
    emailInvalid: "Geçerli bir e-posta adresi girin.",
    language: "Dili değiştir",
  },
  en: {
    title: "Welcome",
    logout_incomplete: "Your Hub session ended, but central sign-out could not be completed. On a shared device, also sign out of your central account.",
    securityCheck: "Security verification",
    challengeFailure: "Security verification could not be completed. Please try again.",
    description: "Sign in to Integration Hub securely with your corporate account.",
    slogans: ["Connected systems", "Flowing data", "Stronger integrations"],
    unavailableTitle: "Sign-in is not enabled yet",
    unavailableDescription: "Corporate sign-in is being prepared. You can continue here once access is available.",
    submit: "Continue", submitting: "Checking access...",
    failed: "Sign-in could not be completed. Sign in again. If the problem continues, contact your administrator.",
    access_denied: "You do not have access to Integration Hub in this organization. Ask your administrator to check your Hub role and access permissions.",
    login_unavailable: "The sign-in service is currently unavailable. Try again shortly. If the problem continues, contact your administrator.",
    rejected: "We could not continue with this account. Check your email address or contact your system administrator.",
    busy: "There are too many sign-in attempts right now. Please try again in a moment.",
    delayed: "The sign-in page could not be opened. Please try again.",
    emailRequired: "Please enter your work email.",
    emailInvalid: "Please enter a valid email address.",
    language: "Change language",
  },
} as const

export type LoginLocale = keyof typeof loginCopy
